"use strict";

var renderUpdateTemplate = require('./renderUpdateTemplate'),
	dropzoneInit = require('./dropzoneInit');

module.exports = function () {
	$('[handlebars-update-template-container]').each(function () {
		var $this = $(this),
			$documentsRow = $('<div class="row"></div>'),
			$umuRow = $('<div class="row"></div>');

		$.ajax($this.data('documentsApiUrl'), {
			"dataType " : "json",
			"success" : function (data) {
				renderUpdateTemplate($documentsRow, data, $this.data('documentsTemplateName'));
			},
			"error": function (data) {
				renderUpdateTemplate($documentsRow, data.responseJSON);
			},
			"complete" : function () {
				$this.append($documentsRow);


				$.ajax($this.data('umuApiUrl'), {
					"dataType " : "json",
					"success" : function (data) {
						renderUpdateTemplate($umuRow, data, $this.data('umuTemplateName'));
					},
					"error": function (data) {
						renderUpdateTemplate($umuRow, data.responseJSON);
					},
					"complete" : function () {
						$this.append($umuRow);
						dropzoneInit();
					}
				});
			}
		});

		$('body').on('submit', '[update-documents-form]', function (event) {
			event.preventDefault();

			var $this = $(this),
				$parent = $this.parent();

			$.ajax($this.attr('action'), {
				"dataType" : "json",
				"success" : function (data) {
					if (data.status == 'success') {
						$parent.html('<div class="alert alert-warning">Данные в процессе обновления.</div>');
					} else {
						$parent.html('<div class="alert alert-danger">В процессе обновления данных произошла ошибка.</div>');
					}
				},
				"error" : function () {
					$parent.html('<div class="alert alert-danger">В процессе обновления данных произошла ошибка.</div>');
				}
			});

			return false;
		});
	});
};